var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDonationHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/heart-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/heart-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0013 45.8334C36.5072 45.8334 45.8346 36.506 45.8346 25.0001C45.8346 13.4941 36.5072 4.16675 25.0013 4.16675C13.4954 4.16675 4.16797 13.4941 4.16797 25.0001C4.16797 36.506 13.4954 45.8334 25.0013 45.8334Z",
    stroke: "#0082CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6875 36.3542C25.3125 36.4792 24.6667 36.4792 24.2917 36.3542C21.0417 35.25 13.75 30.6041 13.75 22.7291C13.75 19.25 16.5417 16.4375 20 16.4375C22.0417 16.4375 23.8542 17.4166 25 18.9583C26.125 17.4375 27.9583 16.4375 30 16.4375C33.4583 16.4375 36.25 19.25 36.25 22.7291C36.25 30.6041 28.9583 35.25 25.6875 36.3542Z",
    stroke: "#0082CD",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationHistory);
export default __webpack_public_path__ + "static/media/donation-history.ed8891477296b414f75e4726e40d8159.svg";
export { ForwardRef as ReactComponent };